import {Component, OnInit} from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {SignupService} from "../../../services/signup.service";
import {ActivatedRoute} from "@angular/router";
import {APIClientService} from "../../../../common/services/apiclient.service";
import {EmailApi} from "../../../../common/apis/email-api";

@Component({
  selector: 'app-merchant-email-confirmation',
  templateUrl: './merchant-email-confirmation.component.html',
  styleUrls: ['./merchant-email-confirmation.component.css']
})
export class MerchantEmailConfirmationComponent implements OnInit {
  token?: string

  constructor(
    public signupService: SignupService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.signupService.currentStepBs.next(this.signupService.Step.EMAIL_CONFIRMATION);
    this.signupService.disableBackButton = false
    this.signupService.disableNextButton = true // TODO: Change to true

    this.token = this.route.snapshot.params['token'];
    console.log("Received token inside MerchantEmailConfirmationComponent = ", this.token)
    if (this.token) {
      this.signupService.verifyEmail(this.token)
    }

    // this.currentStepBs.next(Step.SUCCESS);
    // this.currentStepBs.next(Step.FAILED);
  }


}
